<template>
  <div class="app-container">
  <!-- top -->
    <div class="top_btns clearfix">
      <div class="left_box">
        <!-- 筛选 -->
        <search @success="getList">
          <el-form style="margin:11px 0px 0px -26px;height:270px;width:430px" class="styleForm">
            <el-form-item label="选择类别 ：" :label-width="formLabelWidth">          
              <el-select v-model="wbstatus" placeholder="请选择" size="mini" style="width:200px">
                <el-option label="普通科目余额表" value="">
                </el-option>
                <el-option label="外币科目余额表" value="wb">
                </el-option>
                <el-option label="数量金额科目余额表" value="sl">
                </el-option>
            </el-select>
            </el-form-item>
            <el-form-item label="选择期间 ：" :label-width="formLabelWidth" class="dateFormPeriod" prop="period">
              <el-date-picker size="mini" v-model="listQuery.period" type="month" placeholder="请选择账期" value-format="YYYYMM" format="YYYYMM"></el-date-picker>
            </el-form-item>
            <el-form-item label="会计期间 ：" :label-width="formLabelWidth">
              <el-date-picker size="mini" v-model="listQuery.beginTime" type="month" placeholder="请选择账期" value-format="YYYYMM" format="YYYYMM"></el-date-picker> 
              <span>-</span>
              <el-date-picker size="mini" v-model="listQuery.endTime" type="month" placeholder="请选择账期" value-format="YYYYMM" format="YYYYMM"></el-date-picker> 
            </el-form-item>
            <el-form-item label="选择级别 ：" :label-width="formLabelWidth">
              <el-input placeholder="1" style="width: 90px;" class="filter-item" size="mini" :disabled="true" />
              <span>-</span>
              <el-input placeholder="请输入级别" v-model.number="listQuery.level" style="width: 90px;margin-right:10px" class="filter-item" size="mini" />
            </el-form-item>
            <el-form-item label="会计科目 ：" :label-width="formLabelWidth">
              <hisSubjectList :period="this.listQuery.period" v-model:subjectId="this.listQuery.subjectId"></hisSubjectList>
              <!-- <subject-list-all v-model:subjectId="listQuery.subjectId"></subject-list-all> -->
            </el-form-item>
            <el-form-item label-width="42px" style="height:10px"> 
              <el-checkbox v-model="listQuery.not0" label="余额为0不显示"></el-checkbox>
            </el-form-item>
            <el-form-item label-width="42px">
              <el-checkbox v-model="yearAmount" label="隐藏本年累计发生额"></el-checkbox>
            </el-form-item>
          </el-form>
        </search>
      
      </div>
      <div style="float:right">
        <qzf-import-back @success="getList()" from="历史科目" :comId="this.comId"></qzf-import-back>
      </div>
      <div class="right_box" style="margin-right: 10px;">
        <el-dropdown>
          <qzf-button jz="false" button_code="zb_zz_gd" type="primary" size="mini">
            更多<i class="el-icon-arrow-down el-icon--right"></i>
          </qzf-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item><qzf-button jz="false" button_code="zb_zz_dya4h" @click="printingA5()" type="success" size="mini" plain>打印</qzf-button></el-dropdown-item>
              <el-dropdown-item><qzf-button jz="false" button_code="zb_zz_dc" @click="daochu()" type="info" size="mini" plain>导出</qzf-button></el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      
      
    </div>
    <!-- top end -->

    <el-table show-summary :summary-method="getSummaries" :height="contentStyleObj" size="mini" :data="showList" border style="width: 100%;">
      <el-table-column label="科目编码" width="160" align="center">
        <template #default="scope">
          <span class="bianma">{{scope.row.subjectCode}}</span>
        </template>
      </el-table-column>

      <el-table-column label="科目名称" min-width="240" align="center">
        <template #default="scope">
          <div style="display: flex;justify-content: space-between;">
            <span class="name_css">{{scope.row.subjectName}}</span>
            <!-- <button @click="getSubject(scope.row.subjectCode)" class="sub_btn" style="color: white;background-color: #39b0d2;border: 0;cursor: pointer;border-radius: 5px;" v-if="scope.row.subjectCode.length < 5">匹配科目</button> -->
          </div>
        </template>
      </el-table-column>

      <el-table-column label="期初余额" align="center">
        <el-table-column  align="center" prop="periodBeginIn" label="借方" width="120">
          <template #default="scope">
            <span>{{scope.row.periodBeginIn}}</span>
          </template>
        </el-table-column>
        <el-table-column  align="center" prop="periodBeginOut" label="贷方" width="120">
          <template #default="scope">
            <span>{{scope.row.periodBeginOut}}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="wbstatus == 'wb'" align="center" prop="periodBeginInWb" label="外币借方" width="120">
          <template #default="scope">
            <span>{{scope.row.periodBeginInWb}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="wbstatus == 'wb'" align="center" prop="periodBeginOutWb" label="外币贷方" width="120">
          <template #default="scope">
            <span>{{scope.row.periodBeginOutWb}}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="wbstatus == 'sl'" align="center" prop="beginCount" label="数量" width="120">
          <template #default="scope">
            <span>{{scope.row.beginCount}}</span>
          </template>
        </el-table-column>

      </el-table-column>

      <el-table-column label="本期发生额" align="center">
        <el-table-column align="center" prop="periodInt" label="借方" width="120">
          <template #default="scope">
            <span>{{scope.row.periodInt}}</span>
          </template>
        </el-table-column>  
        <el-table-column align="center" prop="periodOut" label="贷方" width="120">
          <template #default="scope">
            <span>{{scope.row.periodOut}}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="wbstatus == 'wb'" align="center" prop="periodIntWb" label="外币借方" width="120">
          <template #default="scope">
            <span>{{scope.row.periodIntWb}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="wbstatus == 'wb'" align="center" prop="periodOutWb" label="外币贷方" width="120">
          <template #default="scope">
            <span>{{scope.row.periodOutWb}}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="wbstatus == 'sl'" align="center" prop="inCount" label="数量借" width="120">
          <template #default="scope">
            <span>{{scope.row.inCount}}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="wbstatus == 'sl'" align="center" prop="outCount" label="数量贷" width="120">
          <template #default="scope">
            <span>{{scope.row.outCount}}</span>
          </template>
        </el-table-column>

      </el-table-column>

      <el-table-column label="本年累计发生额" align="center" v-if="yearAmount == false">
        <el-table-column align="center" prop="yearInt" label="借方" width="120">
          <template #default="scope">
            <span>{{scope.row.yearInt}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="yearOut" label="贷方" width="120">
          <template #default="scope">
            <span>{{scope.row.yearOut}}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="wbstatus == 'wb'" align="center" prop="yearIntWb" label="外币借方" width="120">
          <template #default="scope">
            <span>{{scope.row.yearIntWb}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="wbstatus == 'wb'" align="center" prop="yearOutWb" label="外币贷方" width="120">
          <template #default="scope">
            <span>{{scope.row.yearOutWb}}</span>
          </template>
        </el-table-column>

      </el-table-column>

      <el-table-column label="期末余额" align="center">
        <el-table-column align="center" prop="periodEndIn" label="借方" width="120">
          <template #default="scope">
            <span>{{scope.row.periodEndIn}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="periodEndOut" label="贷方" width="120">
          <template #default="scope">
            <span>{{scope.row.periodEndOut}}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="wbstatus == 'wb'" align="center" prop="periodEndInWb" label="外币借方" width="120">
          <template #default="scope">
            <span>{{scope.row.periodEndInWb}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="wbstatus == 'wb'" align="center" prop="periodEndOutWb" label="外币贷方" width="120">
          <template #default="scope">
            <span>{{scope.row.periodEndOutWb}}</span>
          </template>
        </el-table-column>


        <el-table-column v-if="wbstatus == 'sl'" align="center" prop="endCount" label="数量" width="120">
          <template #default="scope">
            <span>{{scope.row.endCount}}</span>
          </template>
        </el-table-column>

      </el-table-column>
    </el-table>
    <!-- <el-dialog destroy-on-close title="匹配科目" v-model="dialogSubject">
      <el-form>
        <el-form-item label="科目名称">
          <el-select filterable clearable v-model="bindInfo.newCode" placeholder="请选择" size="mini" @change="changeSubject">
            <el-option v-for="item in bindList" :key="item.id" :label="item.name3" :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button size="mini" @click="dialogSubject = false">取 消</el-button>
          <el-button v-loading.fullscreen.lock="fullscreenLoading" size="mini" type="primary" @click="saveNewSubject">确 定</el-button>
        </div>
      </template>
    </el-dialog> -->
    <!-- <printVouch ref="printVouch" name="book_subject_balance" :listQuery1="this.listQuery"></printVouch>
    <exportFile ref="exportFile" name="book_subject_balance" :listQuery1="this.listQuery"></exportFile> -->
  </div>
</template>

<script>
import { hisSubjectBalance,getOldSubjectBind,saveOldSubjectBind } from "@/api/old"
import hisSubjectList from "./hisSubjectList.vue";
// import printVouch from "./printVouch.vue"
// import exportFile from "./exportFile.vue"
// import { accountBook } from "@/api/printSet"
export default {
  name: 'subjectthis',
  components: {
    hisSubjectList
    // printVouch,
    // exportFile
  },
  data() {
    return {
      name1:'',
      showList:[],
      formLabelWidth: '120px',
      listQuery: {
        comId: this.$store.getters['user/comInfo'].comId*1,
        period: this.$store.getters['user/comInfo'].period,
        not0: false,
        name: '',
        level: 1,
        beginTime:'',
        endTime:'',
        subjectId:0
      },
      contentStyleObj:{},
      wbstatus: '',
      visible:false,
      yearAmount:false,
      checkbox:false,
      // dialogSubject:false,
      bindInfo:{
        newCode:'',
        oldCode:''
      },
    }
  },
  created() {
    this.contentStyleObj= this.$getHeight(200)
    this.getList()
  },
  methods:{
    getList(){
      hisSubjectBalance(this.listQuery).then(res=>{
        this.showList = res.data.data.list
        this.assets = res.data.data.assest
        this.liabilities = res.data.data.liabilities
        this.interests = res.data.data.interests
        this.cost = res.data.data.cost
        this.profitAndLoss = res.data.data.profitAndLoss
      })
    },
    // 匹配科目余额
    // getSubject(e){
    //   this.dialogSubject = true
    //   getOldSubjectBind({oldCode:e}).then(res => {
    //     this.bindList = res.data.data.list
    //     this.bindInfo = res.data.data.info
    //     if(this.bindInfo.oldCode == ''){
    //       this.bindInfo.oldCode = e
    //     } else {
    //       this.bindInfo.oldCode = this.bindInfo.oldCode
    //     }
    //   })
    // },
    // changeSubject(e) {
    //   this.bindInfo.newCode = e;
    // },
    // 保存匹配科目
    // saveNewSubject(){
    //   this.$confirm('确认匹配科目吗?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     this.fullscreenLoading = true
    //     saveOldSubjectBind(this.bindInfo).then(res=>{
    //       this.fullscreenLoading = false
    //       if(res.data.msg == 'success'){
    //         this.dialogSubject = false
    //         this.$message({
    //           message: '匹配成功',
    //           type: 'success'
    //         });
    //         this.getList()
    //       }
    //     })
    //   })
    // },
    // printingA5() {
    //   this.$refs.printVouch.init()
    // },
    // daochu() {
    //   this.$refs.exportFile.init()
    // },
    // printing() {
    //   let params = {
    //     query: this.listQuery,
    //     bookNames: ['book_subject_balance'],
    //     comIds:[this.listQuery.comId],
    //     paperType: "A4-H"
    //   }
    //   if(this.listQuery.endTime<this.listQuery.beginTime) {
    //     this.$message({
    //       showClose: true,
    //       message: '请查看日期起止是否填写正确',
    //       type: 'warning'
    //     });
    //   }else{
    //     console.log(params)
    //     accountBook(params).then(res=>{
    //       if (res.data.msg != "success") {
    //         this.$message.error(res.data.msg);
    //       }else{
    //         window.open(res.data.data.url);  
    //       }
    //     })
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
.top_btns {
  .left_box{
    float: left;
    width: 70%;
    margin-bottom: 10px;
  }
  .right_box {
    float: right;
    width: 20%;
    text-align: right;
  }
}
.styleForm{
  .el-select{
    margin: 0px;
  }
}
.bottom_btns{
  width: 100%;
  margin: 0 auto;
  margin-bottom: 15px;
  .left_box{
    float: left;
    width: 70%;
  }
  .right_box {
    float: right;
    width: 30%;
    text-align: right;
    span{
      color: #F15A24;
    }
  }
}
.sub_btn {
  color: white;
  background-color: #39b0d2;
}
</style>
<style lang="scss">
.message_box_alert{
  width: 800px !important;
}
.styleForm{
  .el-input{
    width: 136px;
  }
}
.el-table__header,.el-table__body,.el-table__footer{
   width: 100%;
   table-layout: fixed !important;
}
</style>